import { Grid } from "@mui/material";
import PageHeader from "../MagazinePage/PageHeader";
import PaperGrid from "../PaperGrid";
import PageFooter from "../MagazinePage/PageFooter";

const MagazinePaper = ({ advertisments, pageNumber, header, title }) => {
  return (
    <Grid
      container
      direction="column"
      paddingX={1}
      paddingY={1}
      className="magazine-paper"
      data-page-variant="magazine-print-paper"
    >
      <PageHeader
        leftContent={header?.leftContent ?? ""}
        centerContent={header?.rightContent ?? ""}
      />
      <PaperGrid title={title} items={advertisments} />
      <PageFooter pageNumber={pageNumber} />
    </Grid>
  );
};

export default MagazinePaper;
